import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SoilTypeApiService } from './services/soil-type-api.service';
import { SoilTypeEffects } from './store/soil-type.effects';
import { soilTypeReducer } from './store/soil-type.reducer';

@NgModule({
  providers: [
    provideState('soilType', soilTypeReducer),
    provideEffects(SoilTypeEffects),
    SoilTypeApiService,
  ],
})
export class SoilTypeModule {}
